var _path, _polyline, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-108"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M292.16,62.08a1.5,1.5,0,0,1-.15.19l-.47.52c-.4.47-1,1.12-1.8,2a49.1,49.1,0,0,0-5.69,8.4A39,39,0,0,0,279.6,88a41,41,0,0,0,3,19.26l.08.19-.2.06a65.24,65.24,0,0,0-33,22.17,63,63,0,0,0-8.14,13.28l-.06.14-.15-.05a46.6,46.6,0,0,0-8.2-1.84c-1.32-.2-2.63-.27-3.89-.36s-2.51-.08-3.7,0a47.58,47.58,0,0,0-12.24,2,48.58,48.58,0,0,0-7.47,2.94c-.84.41-1.45.78-1.88,1l-.49.26c-.11.05-.17.08-.17.07l.16-.1.47-.28c.42-.23,1-.61,1.86-1a45.7,45.7,0,0,1,7.46-3,47.13,47.13,0,0,1,12.29-2.06c1.2-.07,2.44,0,3.72,0s2.59.15,3.92.35a45.51,45.51,0,0,1,8.27,1.83l-.22.09a63.44,63.44,0,0,1,8.15-13.37,65.45,65.45,0,0,1,33.22-22.29l-.12.25a41.14,41.14,0,0,1-3-19.43,38.77,38.77,0,0,1,4.57-14.81,46.35,46.35,0,0,1,5.8-8.37c.77-.9,1.43-1.54,1.85-2l.48-.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.43,62.08a1.94,1.94,0,0,1,.16.26l.43.78c.39.7.93,1.71,1.63,3,1.41,2.61,3.41,6.4,5.84,11.11,4.87,9.42,11.41,22.53,18.24,37.19s12.65,28.11,16.72,37.9c2,4.89,3.66,8.87,4.75,11.62.54,1.37,1,2.43,1.25,3.18.13.35.24.62.32.83a1,1,0,0,1,.09.29s-.05-.09-.13-.28-.21-.47-.35-.81L250.06,164l-4.87-11.57c-4.13-9.76-10-23.18-16.82-37.84S215,86.81,210.24,77.36c-2.41-4.7-4.36-8.51-5.73-11.17l-1.56-3c-.16-.34-.29-.6-.39-.8A2.48,2.48,0,0,1,202.43,62.08Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310,62.23l-.55,0-1.62,0-6.22,0-22.91.07-75.88.06.09-.38,2.17,1.14c26.84,14,50.87,27.21,68.17,36.93,8.65,4.86,15.62,8.83,20.43,11.6l5.52,3.21,1.44.84c.32.19.48.3.48.3l-.5-.27-1.46-.81-5.56-3.13c-4.85-2.72-11.84-6.65-20.49-11.49-17.33-9.66-41.38-22.8-68.21-36.83l-2.17-1.14L202,62h.8l75.88.06,22.91.06,6.22,0,1.62,0C309.82,62.21,310,62.23,310,62.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.09,129.71a7.67,7.67,0,0,1,1.06-.71,13.48,13.48,0,0,1,1.3-.75c.52-.26,1.09-.61,1.77-.88a24,24,0,0,1,2.23-.91,26.53,26.53,0,0,1,2.64-.83,32.59,32.59,0,0,1,6.26-1,32,32,0,0,1,6.32.38,26.55,26.55,0,0,1,2.7.58,23.82,23.82,0,0,1,2.31.69c.7.21,1.3.5,1.85.72a14.15,14.15,0,0,1,1.36.62,7.57,7.57,0,0,1,1.12.61,9.51,9.51,0,0,1-1.19-.47c-.37-.17-.83-.37-1.38-.56s-1.15-.46-1.85-.65a22.15,22.15,0,0,0-2.3-.64,27,27,0,0,0-2.68-.54,32.84,32.84,0,0,0-6.24-.34,33.7,33.7,0,0,0-6.19.92c-.93.25-1.81.49-2.62.79s-1.55.57-2.22.85-1.26.59-1.79.83-1,.48-1.32.68A7.41,7.41,0,0,1,203.09,129.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.86,130.42a3.6,3.6,0,0,1,0-.53c0-.34,0-.86,0-1.51a30.1,30.1,0,0,1,.78-5.52,32.15,32.15,0,0,1,2.91-7.74,31.73,31.73,0,0,1,6.08-8.09,32.29,32.29,0,0,1,16.23-8.26,29.52,29.52,0,0,1,5.55-.52,14.68,14.68,0,0,1,1.51,0,2.19,2.19,0,0,1,.53,0,3.6,3.6,0,0,1-.53,0c-.34,0-.85,0-1.51,0a32,32,0,0,0-27.54,16.89,33,33,0,0,0-3,7.63,32.48,32.48,0,0,0-.89,5.47c-.07.65-.07,1.16-.1,1.5A3.13,3.13,0,0,1,235.86,130.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275,62.08a1.28,1.28,0,0,1-.18.34l-.58.92c-.26.4-.58.88-.9,1.47s-.74,1.23-1.1,2-.81,1.57-1.19,2.49-.77,1.9-1.15,2.95a38,38,0,0,0-2.08,14.25c.07,1.11.12,2.17.27,3.15s.27,1.89.42,2.72.35,1.57.49,2.23.31,1.21.44,1.66l.3,1a1.45,1.45,0,0,1,.07.38,2.19,2.19,0,0,1-.15-.35l-.37-1c-.15-.45-.34-1-.5-1.66s-.41-1.38-.55-2.22-.37-1.74-.48-2.74-.23-2.05-.3-3.17a39.15,39.15,0,0,1,.33-7.3,39.73,39.73,0,0,1,1.76-7.09c.4-1.06.77-2.06,1.2-3s.84-1.74,1.24-2.49.82-1.39,1.16-2a16.25,16.25,0,0,1,1-1.44l.64-.88A2,2,0,0,1,275,62.08Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.75,62.08a5.73,5.73,0,0,1-.71.85,28.33,28.33,0,0,0-1.85,2.36,20.31,20.31,0,0,0-2.11,3.87,18.63,18.63,0,0,0-1.26,5.24,22,22,0,0,0,1.3,9.67,23.61,23.61,0,0,0,1.22,2.73,8.5,8.5,0,0,1,.5,1,5.34,5.34,0,0,1-.63-.91,17.75,17.75,0,0,1-1.35-2.71,20.91,20.91,0,0,1-1.44-9.81A18,18,0,0,1,253,65.13a19.47,19.47,0,0,1,2-2.3A5.35,5.35,0,0,1,255.75,62.08Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.26,112.69a2.75,2.75,0,0,1,0-.39c0-.3.12-.67.19-1.11s.25-1.06.41-1.74.4-1.44.72-2.25a32.46,32.46,0,0,1,7.14-11.6c3.7-3.86,8-6.56,11.44-7.3a9.52,9.52,0,0,1,4.15-.06,7.64,7.64,0,0,1,1.08.35,1.21,1.21,0,0,1,.35.18s-.51-.19-1.46-.38a10,10,0,0,0-4.06.18c-3.38.79-7.55,3.49-11.21,7.31a33.64,33.64,0,0,0-7.17,11.41c-.33.81-.54,1.57-.77,2.22s-.35,1.24-.47,1.71-.19.8-.26,1.09A1.12,1.12,0,0,1,226.26,112.69Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.83,112.41a4.79,4.79,0,0,1,.82-.47,21.6,21.6,0,0,1,2.35-1,22.8,22.8,0,0,1,3.67-1,24.27,24.27,0,0,1,4.66-.44,23.28,23.28,0,0,1,8.29,1.64,21.45,21.45,0,0,1,2.34,1.08,4.3,4.3,0,0,1,.8.48c0,.07-1.21-.56-3.23-1.3a24.31,24.31,0,0,0-16.43-.16C204.06,111.87,202.87,112.48,202.83,112.41Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.09,96.59s.14-.17.44-.43a14.12,14.12,0,0,1,1.36-1,14.06,14.06,0,0,1,10.67-1.94,11.75,11.75,0,0,1,1.62.45c.37.13.58.22.57.25s-.86-.19-2.24-.42a16.24,16.24,0,0,0-5.41,0A16.53,16.53,0,0,0,205,95.41C203.83,96.11,203.13,96.65,203.09,96.59Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,78.42c0,.08-1.35.26-3.42,1a17.63,17.63,0,0,0-1.67.67A19.65,19.65,0,0,0,230,81a25.25,25.25,0,0,0-3.87,2.68,24.54,24.54,0,0,0-3.26,3.4c-.43.58-.86,1.12-1.19,1.67a15.67,15.67,0,0,0-.92,1.55c-1,1.93-1.44,3.25-1.52,3.22a5.49,5.49,0,0,1,.26-.93,9.8,9.8,0,0,1,.39-1.06c.18-.4.35-.88.62-1.36a15.45,15.45,0,0,1,.89-1.59c.33-.57.75-1.13,1.18-1.73a24.62,24.62,0,0,1,3.29-3.48,23.71,23.71,0,0,1,4-2.69,18.73,18.73,0,0,1,1.89-.89,15.88,15.88,0,0,1,1.71-.63,14.75,14.75,0,0,1,1.44-.4,9.35,9.35,0,0,1,1.11-.22A4.3,4.3,0,0,1,237,78.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.87,61.88c.06,0-.5.84-1.12,2.26a16.27,16.27,0,0,0-.88,2.57A18.76,18.76,0,0,0,235.4,70a17.56,17.56,0,0,0,.19,3.31,16,16,0,0,0,.65,2.63c.5,1.47,1,2.31.92,2.34s-.16-.18-.39-.56A11.26,11.26,0,0,1,236,76a14.92,14.92,0,0,1-.74-2.67A16.63,16.63,0,0,1,235,70a17,17,0,0,1,.52-3.36,15.21,15.21,0,0,1,1-2.59,10.51,10.51,0,0,1,.95-1.61C237.69,62.06,237.84,61.87,237.87,61.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.83,62.23c.11,0,.2,24.71.2,55.2s-.09,55.2-.2,55.2-.2-24.71-.2-55.2S202.72,62.23,202.83,62.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.23,264.07l.14.11.39.35c.35.3.84.78,1.52,1.34a35.75,35.75,0,0,0,6.27,4.26,29.12,29.12,0,0,0,11,3.33A30.68,30.68,0,0,0,509,271.2l.15-.06,0,.15A48.8,48.8,0,0,0,525.74,296a47,47,0,0,0,9.93,6.09l.11,0,0,.12a33.8,33.8,0,0,0-1.38,6.13c-.15,1-.2,2-.27,2.91s-.06,1.87,0,2.76a35.28,35.28,0,0,0,1.47,9.15,36.37,36.37,0,0,0,2.2,5.59c.3.63.58,1.09.74,1.41l.19.36.06.13s0,0-.08-.12l-.21-.35c-.17-.31-.46-.77-.77-1.39a34,34,0,0,1-2.28-5.58,34.89,34.89,0,0,1-1.54-9.19c-.05-.9,0-1.83,0-2.78s.11-1.94.26-2.94a34.53,34.53,0,0,1,1.37-6.17l.07.16a47.76,47.76,0,0,1-10-6.1,48.5,48.5,0,0,1-9-9.29,47.93,47.93,0,0,1-7.67-15.55l.19.09a30.81,30.81,0,0,1-14.53,2.24,29.18,29.18,0,0,1-11.08-3.42,35.93,35.93,0,0,1-6.26-4.33c-.67-.59-1.14-1.08-1.48-1.39l-.38-.36Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.23,331.16l.19-.12.58-.32,2.25-1.22c1.95-1.05,4.79-2.54,8.31-4.36,7-3.64,16.84-8.53,27.81-13.64s21-9.46,28.34-12.51c3.66-1.52,6.63-2.73,8.69-3.55l2.37-.93.62-.24.22-.07-.21.1-.61.26-2.35,1-8.65,3.64c-7.3,3.09-17.33,7.47-28.3,12.58s-20.77,10-27.84,13.55l-8.35,4.29L476,330.77l-.59.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.34,250.72s0,.14,0,.41,0,.68,0,1.21c0,1.07,0,2.63,0,4.65,0,4.05,0,9.9.05,17.13,0,14.49,0,34.52,0,56.74l-.28-.07.85-1.62c10.5-20.06,20.36-38,27.62-51,3.63-6.47,6.61-11.68,8.68-15.28l2.39-4.13c.28-.47.49-.82.63-1.07l.23-.36-.2.37c-.14.26-.34.62-.61,1.09L512.45,263l-8.59,15.32c-7.22,13-17.05,30.95-27.54,51-.3.56-.59,1.11-.85,1.62l-.28.54v-.61c0-22.22,0-42.25,0-56.74,0-7.23,0-13.08,0-17.13,0-2,0-3.58,0-4.65,0-.53,0-.93,0-1.21S475.34,250.72,475.34,250.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.8,330.67a5.05,5.05,0,0,1-.53-.79,8.72,8.72,0,0,1-.56-1,13.75,13.75,0,0,1-.66-1.33,14.83,14.83,0,0,1-.68-1.67,18.29,18.29,0,0,1-.62-2,22.16,22.16,0,0,1-.45-9.4c.13-.72.26-1.4.44-2a15.34,15.34,0,0,1,.52-1.72c.16-.53.37-1,.53-1.38a10.32,10.32,0,0,1,.47-1,5.29,5.29,0,0,1,.45-.84,6.32,6.32,0,0,1-.35.89c-.12.28-.27.62-.42,1s-.34.86-.48,1.39-.35,1.09-.48,1.71-.28,1.3-.41,2a25.83,25.83,0,0,0-.25,4.67,25.48,25.48,0,0,0,.69,4.62c.19.7.36,1.36.59,2s.43,1.16.64,1.66.43.95.61,1.34.37.72.52,1A6.22,6.22,0,0,1,525.8,330.67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.33,306.17l-.39,0c-.26,0-.65,0-1.14,0a21.43,21.43,0,0,1-4.12-.58,23.85,23.85,0,0,1-18-18.86,23,23,0,0,1-.39-4.15c0-.49,0-.87,0-1.13a1.6,1.6,0,0,1,0-.4,3.15,3.15,0,0,1,0,.4c0,.26,0,.64,0,1.13a24.16,24.16,0,0,0,.48,4.11,25,25,0,0,0,1.94,5.81,24.54,24.54,0,0,0,4.24,6.16,24.49,24.49,0,0,0,11.67,6.72,24.78,24.78,0,0,0,4.09.68c.49.05.87,0,1.13.07A1.47,1.47,0,0,1,526.33,306.17Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.23,276.94a.83.83,0,0,1,.25.13l.69.43c.3.2.66.43,1.1.68s.92.55,1.49.82,1.17.61,1.86.89,1.42.58,2.2.86a28.71,28.71,0,0,0,10.66,1.55c.83-.05,1.62-.09,2.36-.2s1.41-.2,2-.31,1.17-.26,1.67-.37.9-.23,1.24-.33l.78-.22a1,1,0,0,1,.28-.06s-.08.05-.26.12l-.77.27a11.61,11.61,0,0,1-1.23.38c-.49.12-1,.3-1.67.41s-1.3.27-2,.36-1.54.17-2.38.23a30.36,30.36,0,0,1-5.46-.25,30,30,0,0,1-5.3-1.32c-.79-.3-1.54-.57-2.21-.9s-1.3-.63-1.86-.93-1-.61-1.48-.86-.79-.51-1.07-.72l-.66-.48A1.24,1.24,0,0,1,475.23,276.94Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.23,291.29a5.67,5.67,0,0,1,.63.53,19.66,19.66,0,0,0,1.77,1.38,14.81,14.81,0,0,0,2.89,1.59,14.17,14.17,0,0,0,3.92.94,16.3,16.3,0,0,0,7.23-1,17.39,17.39,0,0,0,2-.91,4.9,4.9,0,0,1,.74-.37,4.44,4.44,0,0,1-.68.47,14.37,14.37,0,0,1-2,1,15.63,15.63,0,0,1-7.34,1.07,13.5,13.5,0,0,1-4-1,14.52,14.52,0,0,1-2.92-1.67,15.35,15.35,0,0,1-1.71-1.46A3.76,3.76,0,0,1,475.23,291.29Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.07,313.34a1.06,1.06,0,0,1-.29,0l-.83-.14c-.36-.07-.79-.18-1.3-.31s-1.08-.29-1.69-.53a24.48,24.48,0,0,1-8.67-5.34c-2.89-2.77-4.9-5.95-5.46-8.56a7,7,0,0,1,0-3.1,4.67,4.67,0,0,1,.26-.8,1.53,1.53,0,0,1,.13-.27s-.14.38-.28,1.09a7.39,7.39,0,0,0,.14,3c.59,2.52,2.6,5.65,5.46,8.38a25.23,25.23,0,0,0,8.53,5.36c.61.25,1.18.41,1.66.58l1.28.35.82.19A1.09,1.09,0,0,1,513.07,313.34Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.86,330.86a4.13,4.13,0,0,1-.35-.61,17,17,0,0,1-.77-1.76,17.32,17.32,0,0,1-.77-2.74,18,18,0,0,1-.33-3.48,17.69,17.69,0,0,1,.4-3.48,16.82,16.82,0,0,1,.83-2.73,15.44,15.44,0,0,1,.8-1.74,2.84,2.84,0,0,1,.37-.6c.05,0-.43.91-1,2.42a18.62,18.62,0,0,0-1.13,6.13,19.13,19.13,0,0,0,1,6.15C512.46,329.94,512.92,330.84,512.86,330.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501,330.67a1.78,1.78,0,0,1-.32-.33,10.38,10.38,0,0,1-.74-1,10.87,10.87,0,0,1-1.52-3.85,11,11,0,0,1,.07-4.14,8,8,0,0,1,.34-1.21c.1-.28.16-.43.18-.42s-.14.64-.31,1.67a12.15,12.15,0,0,0,0,4.05,12.29,12.29,0,0,0,1.41,3.79C500.67,330.12,501.07,330.64,501,330.67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.44,305.33c.07,0,.2,1,.74,2.56a13,13,0,0,0,.5,1.25c.18.44.43.9.68,1.38a18.35,18.35,0,0,0,2,2.89,19.84,19.84,0,0,0,2.54,2.44c.44.32.84.64,1.26.89s.79.49,1.15.69c1.45.78,2.43,1.07,2.41,1.13a3.48,3.48,0,0,1-.69-.19c-.22-.07-.49-.16-.8-.29a9.66,9.66,0,0,1-1-.47A10.32,10.32,0,0,1,495,317c-.43-.25-.85-.56-1.3-.88a19.08,19.08,0,0,1-2.6-2.46,18.68,18.68,0,0,1-2-3,13.8,13.8,0,0,1-.67-1.42A12.65,12.65,0,0,1,488,308c-.14-.4-.21-.77-.29-1.09a5.84,5.84,0,0,1-.17-.83A3.42,3.42,0,0,1,487.44,305.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.08,304.67c0-.05.62.36,1.69.83a12.75,12.75,0,0,0,1.91.66,12.55,12.55,0,0,0,4.93.21,11.31,11.31,0,0,0,2-.49c1.1-.37,1.73-.73,1.76-.68a1.77,1.77,0,0,1-.43.28,7.17,7.17,0,0,1-1.26.6,11,11,0,0,1-2,.56,12.8,12.8,0,0,1-2.54.17,12.47,12.47,0,0,1-2.5-.39,10.15,10.15,0,0,1-1.94-.73,8.18,8.18,0,0,1-1.21-.7A2,2,0,0,1,475.08,304.67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.34,330.86c0-.08,18.48-.15,41.27-.15s41.29.07,41.29.15-18.48.15-41.29.15S475.34,330.94,475.34,330.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584,61.17a5,5,0,0,0,1.5-.37,3.8,3.8,0,0,0,1.44-1.18,3.73,3.73,0,0,0,.74-2.39c0-2,0-4.36,0-7.14,0-1.39,0-2.88,0-4.46,0-.78,0-1.63,0-2.41a3.62,3.62,0,0,0-1.1-2.13,3.51,3.51,0,0,0-2.31-1h-8.76l-13.16,0-30.16,0a3.52,3.52,0,0,0-3.52,3.54v2c0,2.61,0,5.17,0,7.7v3.74a3.59,3.59,0,0,0,1.34,3,3.52,3.52,0,0,0,1.52.7,11,11,0,0,0,1.74.06h3.52l24.63,0,16.61.09,4.51,0,1.18,0a2.12,2.12,0,0,1,.4,0,1.79,1.79,0,0,1-.4,0l-1.18,0-4.51.05-16.61.08-24.63.06h-3.52a10.4,10.4,0,0,1-1.83-.07,4.05,4.05,0,0,1-1.74-.79A4.13,4.13,0,0,1,528,57.12V43.72a4,4,0,0,1,.53-2,4,4,0,0,1,3.51-2l30.16,0,13.16,0,6,0h2.82a3.91,3.91,0,0,1,2.54,1.09,4,4,0,0,1,1.19,2.35c.08.88,0,1.66,0,2.46,0,1.58,0,3.07,0,4.46,0,2.78,0,5.17,0,7.14a4,4,0,0,1-.81,2.49,3.89,3.89,0,0,1-1.52,1.17,3.79,3.79,0,0,1-1.15.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.48,50.4A4.89,4.89,0,0,0,120,50a3.74,3.74,0,0,0,2.17-3.56c0-2,0-4.36,0-7.14,0-1.39,0-2.88,0-4.46,0-.78,0-1.63,0-2.41a3.56,3.56,0,0,0-1.1-2.13,3.51,3.51,0,0,0-2.3-1h-8.77l-13.16,0-30.16,0a3.53,3.53,0,0,0-3.06,1.78A3.48,3.48,0,0,0,63,33V42.6c0,1.27,0,2.52,0,3.75a3.6,3.6,0,0,0,1.35,3,3.47,3.47,0,0,0,1.52.7,11,11,0,0,0,1.74.06h3.52l24.63.05,16.6.09,4.52,0,1.17,0,.4,0-.4,0-1.17,0-4.52,0-16.6.08-24.63.06H67.64a11.42,11.42,0,0,1-1.83-.07,4.05,4.05,0,0,1-1.74-.79,4.1,4.1,0,0,1-1.54-3.43V42.6c0-2.52,0-5.09,0-7.69V33a4.09,4.09,0,0,1,.53-2,4,4,0,0,1,3.51-2l30.16,0,13.16,0h6l2.82,0a4,4,0,0,1,3.73,3.44c.07.88,0,1.66,0,2.46,0,1.58,0,3.07,0,4.46,0,2.78,0,5.17,0,7.14a3.91,3.91,0,0,1-.81,2.49A3.83,3.83,0,0,1,120,50.12a3.66,3.66,0,0,1-1.15.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.08,71.79a4.65,4.65,0,0,0,1.51-.37,3.74,3.74,0,0,0,2.17-3.56c0-2,0-4.37,0-7.14,0-1.4,0-2.89,0-4.46,0-.78,0-1.63,0-2.41a3.52,3.52,0,0,0-1.09-2.13,3.62,3.62,0,0,0-2.31-1h-2.8l-6,0-13.17,0-30.15,0a3.56,3.56,0,0,0-3.07,1.79,3.69,3.69,0,0,0-.46,1.76v13.4a3.57,3.57,0,0,0,1.34,3,3.52,3.52,0,0,0,1.52.7,11,11,0,0,0,1.74.07h3.52l24.63.06L91,71.69l4.51,0,1.17,0a3,3,0,0,1,.4,0,2,2,0,0,1-.4,0l-1.17,0-4.51,0L74.39,72,49.76,72H46.24A12.76,12.76,0,0,1,44.41,72a4.18,4.18,0,0,1-1.74-.79,4.13,4.13,0,0,1-1.54-3.43V64c0-2.52,0-5.09,0-7.69v-2a4.2,4.2,0,0,1,.53-2,4.09,4.09,0,0,1,3.52-2l30.15,0,13.17,0h6l2.82,0A4,4,0,0,1,101,53.8c.07.88,0,1.66,0,2.46,0,1.57,0,3.06,0,4.46,0,2.77,0,5.17,0,7.14a3.87,3.87,0,0,1-.82,2.48,3.77,3.77,0,0,1-1.52,1.18,4,4,0,0,1-1.14.28A1.61,1.61,0,0,1,97.08,71.79Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.13,370.63a5.3,5.3,0,0,0,1.51-.38,3.74,3.74,0,0,0,2.17-3.56c0-2,0-4.36,0-7.14,0-1.4,0-2.88,0-4.46,0-.78,0-1.63-.05-2.41a3.59,3.59,0,0,0-3.4-3.1h-2.8l-6,0-13.16,0-30.15,0a3.56,3.56,0,0,0-3.07,1.79,3.69,3.69,0,0,0-.46,1.76v9.65c0,1.26,0,2.51,0,3.75a3.64,3.64,0,0,0,1.35,3,3.57,3.57,0,0,0,1.52.69,9.93,9.93,0,0,0,1.74.07h3.52l24.63.05,16.6.08,4.52.05,1.17,0a2,2,0,0,1,.4,0l-.4,0-1.17,0-4.52.05-16.6.08-24.63.05h-3.52a11.42,11.42,0,0,1-1.83-.07,4.05,4.05,0,0,1-1.74-.79,4.1,4.1,0,0,1-1.54-3.43v-3.75c0-2.52,0-5.09,0-7.69v-2a4.05,4.05,0,0,1,4.05-4.07l30.15,0,13.16,0h6l2.82,0a4,4,0,0,1,3.73,3.44c.07.88,0,1.66,0,2.46,0,1.58,0,3.06,0,4.46,0,2.78,0,5.17-.05,7.14a3.87,3.87,0,0,1-2.33,3.66,4,4,0,0,1-1.15.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.64,291.67a4.89,4.89,0,0,0,1.51-.38,3.74,3.74,0,0,0,2.17-3.56c0-2,0-4.36-.05-7.14,0-1.39,0-2.88,0-4.46,0-.78,0-1.63,0-2.41a3.62,3.62,0,0,0-1.1-2.13,3.51,3.51,0,0,0-2.3-1H677l-13.16,0-30.16,0a3.52,3.52,0,0,0-3.52,3.54v2c0,2.6,0,5.17,0,7.69v3.75a3.55,3.55,0,0,0,2.87,3.74,11,11,0,0,0,1.74.06h3.52l24.63.05,16.6.09,4.51,0,1.18,0,.4,0-.4,0-1.18,0-4.51,0-16.6.08-24.63.06H634.8a11.58,11.58,0,0,1-1.84-.07,4,4,0,0,1-1.73-.79,4.1,4.1,0,0,1-1.54-3.43c0-1.24,0-2.49,0-3.75v-9.65a4.09,4.09,0,0,1,.53-2,4,4,0,0,1,3.51-2l30.16,0,13.16,0h6l2.82,0a4,4,0,0,1,3.74,3.44c.07.88,0,1.66,0,2.46,0,1.58,0,3.07,0,4.46,0,2.78,0,5.17,0,7.14a4,4,0,0,1-.81,2.49,3.89,3.89,0,0,1-1.52,1.17,3.79,3.79,0,0,1-1.15.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.61,140.6a5.3,5.3,0,0,0,1.51-.38,3.74,3.74,0,0,0,2.17-3.56c0-2,0-4.36,0-7.14,0-1.4,0-2.88,0-4.46,0-.78,0-1.63-.05-2.41a3.59,3.59,0,0,0-3.4-3.1H483l-13.16,0-30.15,0a3.56,3.56,0,0,0-3.07,1.79,3.69,3.69,0,0,0-.46,1.76v9.65c0,1.26,0,2.51,0,3.75a3.63,3.63,0,0,0,1.35,3,3.57,3.57,0,0,0,1.52.69,9.93,9.93,0,0,0,1.74.07h3.52l24.63,0,16.6.08,4.52,0,1.17,0a2,2,0,0,1,.4,0l-.4,0-1.17,0-4.52,0-16.6.08-24.63.06h-3.52a11.42,11.42,0,0,1-1.83-.07,4.05,4.05,0,0,1-1.74-.79,4.1,4.1,0,0,1-1.54-3.43V132.8c0-2.52,0-5.09,0-7.69v-2a4.05,4.05,0,0,1,4.05-4.07l30.15,0,13.16,0h6l2.82,0a4,4,0,0,1,3.73,3.44c.07.88,0,1.66,0,2.46,0,1.58,0,3.06,0,4.46,0,2.78,0,5.17-.05,7.14a3.87,3.87,0,0,1-2.33,3.66,4,4,0,0,1-1.15.28C491.75,140.61,491.61,140.6,491.61,140.6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.14,208.27a4.63,4.63,0,0,0,1.5-.37,3.8,3.8,0,0,0,1.44-1.18,3.72,3.72,0,0,0,.74-2.38c0-2,0-4.37,0-7.15,0-1.39,0-2.88,0-4.46,0-.78,0-1.63,0-2.41a3.62,3.62,0,0,0-1.1-2.13,3.51,3.51,0,0,0-2.31-1H81.54l-13.16,0-30.16,0a3.52,3.52,0,0,0-3.52,3.54v2c0,2.61,0,5.17,0,7.7v3.74a3.59,3.59,0,0,0,1.34,3,3.52,3.52,0,0,0,1.52.7,11,11,0,0,0,1.74.06h3.52l24.63.05,16.61.09,4.51.05,1.18,0a2.12,2.12,0,0,1,.4,0l-.4,0-1.18,0-4.51.05-16.61.08-24.63.06H39.29a10.4,10.4,0,0,1-1.83-.07,3.94,3.94,0,0,1-1.74-.79,4.11,4.11,0,0,1-1.54-3.43v-13.4a4,4,0,0,1,.53-2,4,4,0,0,1,3.51-2l30.16,0,13.16,0,6,0h2.82a4,4,0,0,1,3.73,3.44c.08.88,0,1.66,0,2.46,0,1.58,0,3.07,0,4.46,0,2.78,0,5.18,0,7.15a3.94,3.94,0,0,1-.81,2.48A3.89,3.89,0,0,1,91.69,208a3.79,3.79,0,0,1-1.15.28Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-108"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M699,390.42c0,.14-145.05.26-323.93.26s-324-.12-324-.26,145-.26,324-.26S699,390.28,699,390.42Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Piping--inject-108"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.75,176.46H195.57a8.28,8.28,0,0,0,8.17-8.17V58l-8.17,8.18H466.06L457.88,58v280.6a8.3,8.3,0,0,0,8.18,8.18H647.78c8.58,0,62.89-.29,71.47-.29,10.52,0,10.54-16.36,0-16.36-23.42,0-92.57.29-116,.29H466.06l8.18,8.18V58a8.29,8.29,0,0,0-8.18-8.17H195.57A8.29,8.29,0,0,0,187.39,58V168.29l8.18-8.18H30.75c-10.52,0-10.54,16.35,0,16.35Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.92,66.68c-.1,0-.31-1.22-1-3.1a20.68,20.68,0,0,0-1.56-3.14A22.44,22.44,0,0,0,198.7,57a22.83,22.83,0,0,0-3.26-2.8,20.81,20.81,0,0,0-3.06-1.74c-1.83-.83-3.06-1.11-3-1.2a2.61,2.61,0,0,1,.87.13,9.22,9.22,0,0,1,1,.27,11.75,11.75,0,0,1,1.3.47,18,18,0,0,1,3.18,1.68,20.92,20.92,0,0,1,3.37,2.83,21.54,21.54,0,0,1,2.65,3.53,18.34,18.34,0,0,1,1.5,3.27c.18.47.28.93.39,1.32a7.74,7.74,0,0,1,.21,1A3.22,3.22,0,0,1,203.92,66.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.19,
    y: 142.48,
    width: 20.67,
    height: 7.31,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206,149.74c0,.14-4.59.26-10.26.26s-10.26-.12-10.26-.26,4.59-.26,10.26-.26S206,149.6,206,149.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206,142.48c0,.14-4.63.26-10.35.26s-10.35-.12-10.35-.26a100.92,100.92,0,0,1,10.35-.26A100.92,100.92,0,0,1,206,142.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 439.22,
    y: 54.42,
    width: 20.67,
    height: 7.31,
    transform: "translate(391.48 507.63) rotate(-90)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.16,47.62a99.18,99.18,0,0,1,.26,10.26,99.34,99.34,0,0,1-.26,10.26c-.14,0-.26-4.6-.26-10.26S453,47.62,453.16,47.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.9,47.62A100.92,100.92,0,0,1,446.16,58a101.08,101.08,0,0,1-.26,10.35c-.14,0-.26-4.64-.26-10.35S445.76,47.62,445.9,47.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 455.57,
    y: 82.76,
    width: 20.67,
    height: 7.31,
    transform: "matrix(-1, 0, 0, -1, 931.82, 172.83)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.45,82.81a99.18,99.18,0,0,1,10.26-.26,99.18,99.18,0,0,1,10.26.26c0,.14-4.59.26-10.26.26S455.45,83,455.45,82.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.45,90.07a100.92,100.92,0,0,1,10.35-.26,100.92,100.92,0,0,1,10.35.26c0,.14-4.63.26-10.35.26S455.45,90.21,455.45,90.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 484.02,
    y: 333.56,
    width: 20.67,
    height: 7.31,
    transform: "translate(831.57 -157.14) rotate(90)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.75,347.67a99.18,99.18,0,0,1-.26-10.26,99.18,99.18,0,0,1,.26-10.26c.14,0,.26,4.59.26,10.26S490.89,347.67,490.75,347.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498,347.67a100.92,100.92,0,0,1-.26-10.35A100.92,100.92,0,0,1,498,327c.14,0,.26,4.63.26,10.35S498.15,347.67,498,347.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 455.96,
    y: 308.24,
    width: 20.67,
    height: 7.31,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.75,315.5c0,.14-4.59.26-10.26.26s-10.26-.12-10.26-.26a99.34,99.34,0,0,1,10.26-.26A99.18,99.18,0,0,1,476.75,315.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.75,308.24c0,.14-4.63.26-10.35.26s-10.35-.12-10.35-.26A99.23,99.23,0,0,1,466.4,308,99.07,99.07,0,0,1,476.75,308.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.59,
    y: 54.38,
    width: 20.67,
    height: 7.31,
    transform: "translate(382.96 -266.89) rotate(90)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.32,68.49a99.18,99.18,0,0,1-.26-10.26A99.34,99.34,0,0,1,321.32,48c.14,0,.26,4.6.26,10.26S321.46,68.49,321.32,68.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.58,68.49c-.14,0-.26-4.63-.26-10.35s.12-10.35.26-10.35.26,4.64.26,10.35S328.72,68.49,328.58,68.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.11,
    y: 164.99,
    width: 20.67,
    height: 7.31,
    transform: "translate(340.1 -2.8) rotate(90)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.84,179.1c-.14,0-.26-4.59-.26-10.26s.12-10.26.26-10.26a99.34,99.34,0,0,1,.26,10.26A99.18,99.18,0,0,1,167.84,179.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.1,179.1c-.14,0-.26-4.63-.26-10.35s.12-10.35.26-10.35a101.08,101.08,0,0,1,.26,10.35A100.92,100.92,0,0,1,175.1,179.1Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bricks--inject-108"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M692.76,368a4.63,4.63,0,0,0,1.5-.37,3.8,3.8,0,0,0,1.44-1.18,3.72,3.72,0,0,0,.74-2.38c0-2,0-4.37-.05-7.15,0-1.39,0-2.88,0-4.46,0-.78,0-1.62,0-2.41a3.64,3.64,0,0,0-1.1-2.13,3.51,3.51,0,0,0-2.31-1h-8.76L671,347l-30.16,0a3.52,3.52,0,0,0-3.52,3.54v2c0,2.61,0,5.17,0,7.7V364a3.59,3.59,0,0,0,1.34,3,3.52,3.52,0,0,0,1.52.7,12.35,12.35,0,0,0,1.74.07h3.52l24.63.06,16.61.08,4.51.05,1.18,0a2.12,2.12,0,0,1,.4,0l-.4,0-1.18,0-4.51.05-16.61.08-24.63.06h-3.52a10.4,10.4,0,0,1-1.83-.07,3.94,3.94,0,0,1-1.74-.79A4.11,4.11,0,0,1,636.8,364V350.59a4,4,0,0,1,4-4.06l30.16,0,13.16,0,6,0h2.82a4,4,0,0,1,3.73,3.45c.08.87,0,1.65,0,2.45,0,1.58,0,3.07,0,4.46,0,2.78,0,5.18,0,7.15a3.94,3.94,0,0,1-.81,2.48,3.8,3.8,0,0,1-1.52,1.17,3.51,3.51,0,0,1-1.15.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.15,114.65a5.3,5.3,0,0,0,1.51-.38,3.74,3.74,0,0,0,2.17-3.56c0-2,0-4.36-.05-7.14,0-1.4,0-2.88,0-4.46,0-.78,0-1.63,0-2.41a3.62,3.62,0,0,0-1.1-2.13,3.51,3.51,0,0,0-2.3-1h-8.77l-13.16,0-30.16,0a3.54,3.54,0,0,0-3.06,1.79,3.48,3.48,0,0,0-.46,1.76v2c0,2.6,0,5.17,0,7.69v3.75a3.52,3.52,0,0,0,2.87,3.73,9.85,9.85,0,0,0,1.74.07h3.52l24.63,0,16.6.08,4.51,0,1.18,0a2.12,2.12,0,0,1,.4,0l-.4,0-1.18,0-4.51,0-16.6.08-24.63.06h-3.52a11.58,11.58,0,0,1-1.84-.07,4,4,0,0,1-1.73-.79,4.1,4.1,0,0,1-1.54-3.43c0-1.24,0-2.49,0-3.75V97.2a4,4,0,0,1,.53-2,4.07,4.07,0,0,1,3.51-2.05l30.16,0,13.16,0h6l2.82,0a3.88,3.88,0,0,1,2.54,1.09,3.94,3.94,0,0,1,1.19,2.35c.08.88,0,1.66,0,2.46,0,1.58,0,3.06,0,4.46,0,2.78,0,5.17,0,7.14a3.92,3.92,0,0,1-.81,2.48,3.84,3.84,0,0,1-1.52,1.18,4.12,4.12,0,0,1-1.15.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.75,136a4.65,4.65,0,0,0,1.51-.37,3.83,3.83,0,0,0,1.44-1.17,3.76,3.76,0,0,0,.73-2.39c0-2,0-4.37,0-7.15,0-1.39,0-2.88,0-4.46,0-.77,0-1.62,0-2.41a3.59,3.59,0,0,0-3.4-3.1h-2.8l-6,0L661,115l-30.15,0a3.57,3.57,0,0,0-3.07,1.78,3.64,3.64,0,0,0-.46,1.76v9.66c0,1.26,0,2.51,0,3.75a3.58,3.58,0,0,0,1.35,3,3.47,3.47,0,0,0,1.52.7,12.35,12.35,0,0,0,1.74.07h3.52l24.63.06,16.6.08,4.52.05,1.17,0a1.71,1.71,0,0,1,.4,0,2,2,0,0,1-.4,0l-1.17,0-4.52,0-16.6.09-24.63.05h-3.52a12.71,12.71,0,0,1-1.83-.07A4.07,4.07,0,0,1,626.8,132v-3.75c0-2.52,0-5.09,0-7.7v-2a4.05,4.05,0,0,1,4.05-4.06l30.15,0,13.16,0h6l2.82,0a4,4,0,0,1,3.73,3.44c.07.87,0,1.66,0,2.45,0,1.58,0,3.07,0,4.46,0,2.78,0,5.18,0,7.15a3.87,3.87,0,0,1-2.33,3.66,4,4,0,0,1-1.15.28A2.47,2.47,0,0,1,682.75,136Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.13,253.47a5.43,5.43,0,0,0,1.5-.37,3.81,3.81,0,0,0,1.43-1.17,3.63,3.63,0,0,0,.74-2.37c0-2,0-4.35,0-7.11,0-1.39,0-2.87,0-4.44,0-.78,0-1.62,0-2.41a3.67,3.67,0,0,0-1-2.15,3.63,3.63,0,0,0-2.27-1c-.88,0-1.83,0-2.78,0l-5.94,0-13.1,0-30,0a3.55,3.55,0,0,0-3.05,1.77A3.48,3.48,0,0,0,214,236v1.95q0,3.9,0,7.66v3.73a3.63,3.63,0,0,0,1.27,3.07,3.53,3.53,0,0,0,1.49.73,8.06,8.06,0,0,0,1.72.09H222l24.52.05,16.52.08,4.5,0,1.17,0,.4,0-.4,0-1.17,0-4.5,0-16.52.08-24.52.06h-3.51a8.74,8.74,0,0,1-1.82-.1,4,4,0,0,1-1.71-.83,4.31,4.31,0,0,1-1.15-1.55,4.8,4.8,0,0,1-.31-1.9V236a4.05,4.05,0,0,1,4-4l30,0,13.1,0h5.94c1,0,1.87,0,2.81,0a3.94,3.94,0,0,1,2.5,1.15,4.05,4.05,0,0,1,1.13,2.37c0,.87,0,1.65,0,2.45,0,1.57,0,3.05,0,4.44,0,2.76,0,5.15,0,7.11a3.89,3.89,0,0,1-.82,2.47,3.83,3.83,0,0,1-1.52,1.16,3.68,3.68,0,0,1-1.14.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.74,274.85a4.93,4.93,0,0,0,1.37-.31,3.75,3.75,0,0,0,1.36-1,3.65,3.65,0,0,0,.92-2.05c.05-1.73,0-3.91,0-6.41,0-1.25,0-2.59,0-4,0-.71,0-1.44,0-2.19a15.61,15.61,0,0,0-.08-2.27,3.61,3.61,0,0,0-3.32-2.84h-5.34l-11.83,0-27.1,0a3.53,3.53,0,0,0-2.86,1.47,3.35,3.35,0,0,0-.62,1.51,13.83,13.83,0,0,0,0,1.72v6.92c0,1.13,0,2.25,0,3.37v1.66a5,5,0,0,0,.15,1.56,3.55,3.55,0,0,0,1.91,2.22,3.81,3.81,0,0,0,1.44.32h1.57l22.14.06,14.92.08,4.06.05,1.06,0a1.35,1.35,0,0,1,.35,0l-.35,0-1.06,0-4.06.05-14.92.09-22.14,0h-1.57a3.91,3.91,0,0,1-1.64-.36,4,4,0,0,1-2.19-2.52,5.56,5.56,0,0,1-.17-1.7v-5c0-2.27,0-4.58,0-6.92,0-.59,0-1.15.05-1.8a4.14,4.14,0,0,1,.71-1.74,4.09,4.09,0,0,1,3.29-1.68l27.1,0,11.83,0,5.37,0a4,4,0,0,1,3.65,3.17,15.55,15.55,0,0,1,.07,2.34c0,.75,0,1.48,0,2.19,0,1.41,0,2.75,0,4,0,2.51,0,4.65-.08,6.44a3.74,3.74,0,0,1-1,2.13,3.82,3.82,0,0,1-1.43,1,3.57,3.57,0,0,1-1,.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.5,121a4.59,4.59,0,0,0,1.51-.37,3.74,3.74,0,0,0,2.17-3.56c0-2,0-4.37,0-7.15,0-1.39,0-2.88,0-4.46,0-.77,0-1.62-.05-2.41a3.57,3.57,0,0,0-3.4-3.1h-2.8l-6,0-13.16,0-30.16,0a3.54,3.54,0,0,0-3.06,1.78,3.65,3.65,0,0,0-.47,1.76v13.41a3.57,3.57,0,0,0,1.34,3,3.52,3.52,0,0,0,1.52.7,11,11,0,0,0,1.74.07h3.52l24.63.06,16.61.08,4.51.05,1.17,0a1.71,1.71,0,0,1,.4,0,2,2,0,0,1-.4,0l-1.17,0-4.51,0-16.61.09-24.63,0h-3.52a12.76,12.76,0,0,1-1.83-.07,4.07,4.07,0,0,1-3.28-4.22V103.53a4,4,0,0,1,4-4.06l30.16,0,13.16,0h6l2.82,0a4,4,0,0,1,3.73,3.44c.08.87,0,1.66,0,2.45,0,1.58,0,3.07,0,4.46,0,2.78,0,5.18,0,7.15a3.87,3.87,0,0,1-.82,2.48,3.77,3.77,0,0,1-1.52,1.18,4,4,0,0,1-1.14.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.11,142.38a4.65,4.65,0,0,0,1.51-.37,3.77,3.77,0,0,0,1.43-1.18,3.66,3.66,0,0,0,.74-2.38c0-2,0-4.37-.05-7.15,0-1.39,0-2.88,0-4.46,0-.78,0-1.63,0-2.41a3.64,3.64,0,0,0-1.1-2.13,3.51,3.51,0,0,0-2.3-1h-8.77l-13.16,0-30.16,0a3.52,3.52,0,0,0-3.52,3.54v2c0,2.61,0,5.17,0,7.7v3.75a3.59,3.59,0,0,0,1.34,3,3.51,3.51,0,0,0,1.53.7,11,11,0,0,0,1.74.06h3.52l24.62.05,16.61.09,4.51.05,1.18,0,.4,0-.4,0-1.18,0-4.51,0-16.61.08-24.62.06h-3.52a10.51,10.51,0,0,1-1.84-.07,3.9,3.9,0,0,1-1.73-.79,4.08,4.08,0,0,1-1.54-3.42c0-1.24,0-2.49,0-3.75v-9.66a4,4,0,0,1,4-4.06l30.16,0,13.16,0,6,0h2.82a4,4,0,0,1,3.73,3.44c.08.88,0,1.66,0,2.46,0,1.58,0,3.07,0,4.46,0,2.78,0,5.18,0,7.15a3.94,3.94,0,0,1-.81,2.48,3.89,3.89,0,0,1-1.52,1.17,3.79,3.79,0,0,1-1.15.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.5,123.2a4.87,4.87,0,0,0,1.5-.38,3.6,3.6,0,0,0,1.44-1.17,3.73,3.73,0,0,0,.74-2.39c0-2,0-4.36-.05-7.14,0-1.4,0-2.88,0-4.46,0-.78,0-1.63,0-2.41a3.62,3.62,0,0,0-1.1-2.13,3.51,3.51,0,0,0-2.3-1H154.9l-13.16,0-30.16,0a3.52,3.52,0,0,0-3.52,3.54v2c0,2.6,0,5.17,0,7.69v3.75a3.52,3.52,0,0,0,2.87,3.73,9.85,9.85,0,0,0,1.74.07h3.51l24.63.05,16.61.08,4.51,0,1.18,0a2.12,2.12,0,0,1,.4,0l-.4,0-1.18,0-4.51,0-16.61.08-24.63.06h-3.51a11.58,11.58,0,0,1-1.84-.07,4,4,0,0,1-1.73-.79,4.1,4.1,0,0,1-1.54-3.43c0-1.24,0-2.49,0-3.75v-9.65a4,4,0,0,1,.53-2,4.07,4.07,0,0,1,3.51-2l30.16,0,13.16,0h6l2.82,0a3.88,3.88,0,0,1,2.54,1.09,3.94,3.94,0,0,1,1.19,2.35c.08.88,0,1.66,0,2.46,0,1.58,0,3.06,0,4.46,0,2.78,0,5.17,0,7.14a3.92,3.92,0,0,1-.81,2.48,3.84,3.84,0,0,1-1.52,1.18,4.12,4.12,0,0,1-1.15.28Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-108"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.8,330.92a13.1,13.1,0,0,1,6.75,7.65,23,23,0,0,1,.89,10.36c-.76,6.72-4.88,14.72-9,20.09-5.66-4.94-6.66-14.77-7-19.18-.61-7,2.52-20,8.4-18.92",
    style: {
      fill: "#00274C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.56,376.88c-1.4-3.64.51-7.56,3-10.53A14.77,14.77,0,0,1,138,361.54c1.8-.1,3.8.16,5,1.5a4.74,4.74,0,0,1,.71,4.76,9.66,9.66,0,0,1-3.07,4c-4.45,3.7-9.76,6-15.48,5.07",
    style: {
      fill: "#00274C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.79,381.27c0-8.6-7-15.85-14.45-19.4-1.89-.91-4.36-1.5-5.91-.09s-1.21,3.93-.45,5.89c3.17,8.15,12.07,13.71,20.81,13.6",
    style: {
      fill: "#00274C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.4,385.63c-.07,0-.74-1.16-2-3A52.58,52.58,0,0,0,107.81,370c-1.74-1.37-2.88-2.14-2.83-2.22a3.87,3.87,0,0,1,.86.46c.54.31,1.29.81,2.19,1.46a44,44,0,0,1,6.5,5.8,44.55,44.55,0,0,1,5.22,7c.58,1,1,1.75,1.28,2.31A3.14,3.14,0,0,1,121.4,385.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.4,346.73a10.2,10.2,0,0,1,0,1.72c-.07,1.19-.15,2.77-.26,4.67-.22,3.95-.42,9.41-.46,15.44s0,11.42,0,15.46c0,2,0,3.57-.06,4.68a10.23,10.23,0,0,1-.1,1.72,11.8,11.8,0,0,1-.1-1.72c0-1.19-.06-2.77-.1-4.68-.07-4-.17-9.42-.13-15.46s.3-11.51.61-15.46c.16-2,.3-3.57.43-4.67A11.7,11.7,0,0,1,122.4,346.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.74,367.47c0,.09-1.11.53-2.78,1.57a26.24,26.24,0,0,0-2.79,2,33,33,0,0,0-3,2.94,31.56,31.56,0,0,0-4.38,6.3c-.92,1.74-1.33,2.9-1.42,2.87a3,3,0,0,1,.21-.85,16.19,16.19,0,0,1,.88-2.19,27.23,27.23,0,0,1,4.32-6.47,28.42,28.42,0,0,1,3.11-3,22.47,22.47,0,0,1,2.9-2,12.42,12.42,0,0,1,1.2-.61,7.27,7.27,0,0,1,.94-.4A3.34,3.34,0,0,1,135.74,367.47Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Hole--inject-108"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M582.83,360h0a13.93,13.93,0,0,0-13.89,13.89v16.66H596.2V373.36A13.37,13.37,0,0,0,582.83,360Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.14,360.32c-6.37,1.3-11.22,7.78-11.22,15.6v14.32h22.45V375.92C597.37,368.1,592.52,361.62,586.14,360.32Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Grille--inject-108"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 55.83,
    y: 233.21,
    width: 121.1,
    height: 87.46,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "78 312.98 68.1 313.16 68.1 243.32 78 243.32 78 312.98",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.78,
    y: 243.62,
    width: 9.9,
    height: 69.19,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.46,
    y: 243.62,
    width: 9.9,
    height: 69.19,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.14,
    y: 243.62,
    width: 9.9,
    height: 69.19,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "164.73 313.16 154.82 312.97 154.82 243.13 164.73 243.13 164.73 313.16",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.15,240.05a3.28,3.28,0,1,1-3.27-3.28A3.27,3.27,0,0,1,64.15,240.05Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.15,240.05c-.06,0-.08-.3-.24-.77a3.21,3.21,0,0,0-1.21-1.63,3,3,0,0,0-2.82-.36,2.94,2.94,0,0,0,0,5.51,3,3,0,0,0,2.82-.36,3.21,3.21,0,0,0,1.21-1.63c.16-.47.18-.77.24-.76s.12.29,0,.83a3.24,3.24,0,0,1-1.17,2,3.49,3.49,0,0,1-3.37.59,3.6,3.6,0,0,1,0-6.79,3.49,3.49,0,0,1,3.37.59,3.24,3.24,0,0,1,1.17,2C64.27,239.75,64.19,240.05,64.15,240.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.88,238.19c.13.16-.59,1-1.51,1.9s-1.73,1.64-1.89,1.51.42-1.07,1.37-2S62.75,238,62.88,238.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2,241.21c-.09.18-1.14-.19-2.27-.93s-1.9-1.54-1.77-1.7,1.06.37,2.17,1.09S63.3,241,63.2,241.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.67,314.37a3.28,3.28,0,1,1-3.27-3.27A3.27,3.27,0,0,1,175.67,314.37Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.67,314.37c-.06,0-.08-.29-.24-.76a3.17,3.17,0,0,0-1.21-1.63,3,3,0,0,0-4.73,2.39,3,3,0,0,0,1.91,2.76,3,3,0,0,0,2.82-.36,3.25,3.25,0,0,0,1.21-1.63c.16-.48.18-.77.24-.77s.12.29,0,.84a3.27,3.27,0,0,1-1.17,2,3.52,3.52,0,0,1-3.37.59,3.6,3.6,0,0,1,0-6.79,3.52,3.52,0,0,1,3.37.58,3.29,3.29,0,0,1,1.17,2C175.79,314.08,175.71,314.37,175.67,314.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.4,312.51c.13.16-.59,1-1.51,1.9s-1.73,1.65-1.89,1.52.42-1.08,1.37-2S174.27,312.36,174.4,312.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.72,315.54c-.09.18-1.14-.19-2.27-.93s-1.9-1.55-1.77-1.71,1.06.38,2.17,1.09S174.82,315.36,174.72,315.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.67,239.34a3.28,3.28,0,1,1-3.27-3.28A3.26,3.26,0,0,1,175.67,239.34Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.67,239.34c-.06,0-.08-.29-.24-.77a3.25,3.25,0,0,0-1.21-1.63,3,3,0,0,0-2.82-.36,2.94,2.94,0,0,0,0,5.51,3,3,0,0,0,2.82-.36,3.21,3.21,0,0,0,1.21-1.63c.16-.47.18-.76.24-.76s.12.29,0,.83a3.29,3.29,0,0,1-1.17,2,3.52,3.52,0,0,1-3.37.58,3.6,3.6,0,0,1,0-6.79,3.52,3.52,0,0,1,3.37.59,3.24,3.24,0,0,1,1.17,2C175.79,239,175.71,239.34,175.67,239.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.4,237.48c.13.16-.59,1-1.51,1.9s-1.73,1.65-1.89,1.51.42-1.07,1.37-2S174.27,237.33,174.4,237.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.72,240.5c-.09.18-1.14-.19-2.27-.93s-1.9-1.54-1.77-1.7,1.06.37,2.17,1.09S174.82,240.32,174.72,240.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.48,315a3.28,3.28,0,1,1-3.28-3.28A3.27,3.27,0,0,1,65.48,315Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.48,315c-.06,0-.09-.29-.25-.77A3.25,3.25,0,0,0,64,312.62a3,3,0,0,0-2.82-.36,2.95,2.95,0,0,0,0,5.52,3,3,0,0,0,2.82-.36,3.23,3.23,0,0,0,1.21-1.64c.16-.47.19-.76.25-.76s.12.29,0,.83a3.29,3.29,0,0,1-1.17,2,3.52,3.52,0,0,1-3.37.58,3.6,3.6,0,0,1,0-6.79,3.55,3.55,0,0,1,3.37.59,3.27,3.27,0,0,1,1.17,2C65.6,314.73,65.52,315,65.48,315Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2,313.16c.13.16-.58,1-1.51,1.9s-1.73,1.65-1.88,1.52.41-1.08,1.36-2S64.07,313,64.2,313.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.52,316.19c-.09.17-1.14-.19-2.27-.93s-1.9-1.55-1.77-1.71,1.07.37,2.17,1.09S64.62,316,64.52,316.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.86,243.32c0,.2-22.51.36-50.27.36s-50.27-.16-50.27-.36,22.5-.37,50.27-.37S166.86,243.11,166.86,243.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.86,313.16c0,.21-22.51.37-50.27.37s-50.27-.16-50.27-.37,22.5-.37,50.27-.37S166.86,313,166.86,313.16Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-108"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 345.88,
    cy: 425.24,
    rx: 171.45,
    ry: 20.8,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.13,349.72c.66,1.1,46.43,59.46,46.43,59.46l60,36-13.63,14.34s-65.13-16.23-72.2-24.08-34.81-39.13-34.81-39.13Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.65,424.73a2.4,2.4,0,0,1,.17-.75,11.71,11.71,0,0,1,.78-1.93,17.8,17.8,0,0,1,10.13-8.89,12.27,12.27,0,0,1,2-.52c.49-.08.76-.11.76-.07s-1,.3-2.65.94a19.77,19.77,0,0,0-5.72,3.49,20.18,20.18,0,0,0-4.22,5.22C452.09,423.73,451.74,424.76,451.65,424.73Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.46,451.18l17.16,10.59a5.75,5.75,0,0,1,2,2l6.43,10.8a3.23,3.23,0,0,1-4,4.55l-.13-.05s-4.64,1.48-7.29-.42-8.06-10.36-8.06-10.36l-4.77-.64,5.63,11.07s-4.41,1.52-7.3-1-7.45-9.57-7.45-9.57l-8-2.14s-4.13,2.35-11.07.82c0,0,.14,9.28-6.2,12.08-2.91,1.27-2.7-3.29-2.7-3.29l.84-7.08c-.06-.61-.83-2.48-.68-3.07l3.34-13.26,8.95-8.47Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.41,465.56a8.7,8.7,0,0,1,1.14.66l3.12,2h0l0,0c1.36,1.84,3.16,4.27,5.35,7,.55.69,1.12,1.4,1.73,2.12a5.79,5.79,0,0,0,2.1,1.82,6.24,6.24,0,0,0,2.91.32,12.63,12.63,0,0,0,3.05-.67l-.14.36c-.54-1-1.12-2.11-1.71-3.21l-5.83-11,.09.09-10.4-6.48-2.94-1.88a7.27,7.27,0,0,1-1-.71,8.29,8.29,0,0,1,1.09.58l3,1.77,10.5,6.32.06,0,0,.06c1.77,3.31,3.77,7,5.87,11l1.71,3.21.14.26-.28.1a13.42,13.42,0,0,1-3.19.7,6.58,6.58,0,0,1-3.14-.38,4.68,4.68,0,0,1-.7-.37,5.84,5.84,0,0,1-.59-.51c-.35-.36-.66-.72-1-1.09-.61-.73-1.18-1.45-1.73-2.15-2.17-2.8-3.92-5.26-5.24-7.14l0,0-3-2.08A7.47,7.47,0,0,1,549.41,465.56Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.1,465.59a2.93,2.93,0,0,1,.69.12l1.93.47,7,1.82.07,0,0,.07a55.82,55.82,0,0,0,4.63,6.68,16.4,16.4,0,0,0,3.34,3.2,7.56,7.56,0,0,0,4.63,1.11,5,5,0,0,0,1.83-.55l-.09.33c-2.87-5.55-5.46-10.59-7.49-14.51l.06.07-5.47-4.28L539.85,459a3,3,0,0,1-.49-.45,3.82,3.82,0,0,1,.56.36l1.54,1.11,5.56,4.14,0,0,0,0c2,3.91,4.69,8.92,7.6,14.45l.12.22-.21.12a5.27,5.27,0,0,1-2.05.64,8,8,0,0,1-5-1.2,16.25,16.25,0,0,1-3.44-3.32,53.33,53.33,0,0,1-4.6-6.79l.12.09-7-2-1.9-.57A4,4,0,0,1,530.1,465.59Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.75,479c0-.06.3.06.82.06a3.19,3.19,0,0,0,2-.74,10.34,10.34,0,0,0,2.15-2.5c.35-.53.7-1.1,1-1.69a9.52,9.52,0,0,0,.79-1.93,28.63,28.63,0,0,0,1-6v-.11l.08,0c1.14-.77,2.08-1.4,2.75-1.82a5.32,5.32,0,0,1,1.08-.62s-.31.33-.94.82-1.54,1.16-2.65,2l.09-.17a24.89,24.89,0,0,1-.93,6.1,9.15,9.15,0,0,1-.85,2q-.53.91-1.08,1.71a9.57,9.57,0,0,1-2.34,2.52,3.19,3.19,0,0,1-2.24.65,2.15,2.15,0,0,1-.62-.15C512.81,479,512.74,479,512.75,479Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.72,451.93a37.62,37.62,0,0,0-2.34,4,37.13,37.13,0,0,0-1.32,4.47,10.49,10.49,0,0,1,3.66-8.5Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.65,349.72c-.65,1.1-46.42,59.46-46.42,59.46l-60,36,13.63,14.34s65.12-16.23,72.2-24.08,34.81-39.13,34.81-39.13Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.14,424.73c-.09,0-.44-1-1.28-2.51a19.57,19.57,0,0,0-9.93-8.71c-1.61-.64-2.67-.85-2.66-.94s.28,0,.77.07a12.27,12.27,0,0,1,2,.52,17.8,17.8,0,0,1,10.13,8.89A12.68,12.68,0,0,1,234,424,2.4,2.4,0,0,1,234.14,424.73Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.67,450.35l-17.16,10.59a5.78,5.78,0,0,0-2.05,2L113,473.77a3.23,3.23,0,0,0,4,4.55l.13-.06s4.64,1.49,7.29-.41,8.06-10.36,8.06-10.36l4.76-.64-5.62,11.07s4.41,1.52,7.3-1,7.45-9.57,7.45-9.57l8-2.15s4.13,2.35,11.07.83c0,0-.14,9.28,6.2,12.07,2.91,1.28,2.7-3.28,2.7-3.28l-.84-7.09c0-.61.83-2.47.68-3.07l-3.34-13.25L162,443Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.72,464.74a9.44,9.44,0,0,1-1.05.78l-3,2.09,0,0c-1.32,1.87-3.07,4.33-5.24,7.14-.55.7-1.12,1.42-1.73,2.15-.31.36-.62.73-1,1.09-.17.17-.39.34-.59.51a4.68,4.68,0,0,1-.7.37,6.83,6.83,0,0,1-3.14.38,13.42,13.42,0,0,1-3.19-.7l-.28-.1.14-.27,1.71-3.2c2.1-3.94,4.1-7.67,5.87-11l0-.06.06,0,10.5-6.33,3-1.76a7,7,0,0,1,1.09-.58,7.27,7.27,0,0,1-1,.71l-2.94,1.87-10.4,6.49.09-.09-5.83,11c-.59,1.1-1.17,2.18-1.71,3.21l-.14-.37a12.66,12.66,0,0,0,3,.68,6.13,6.13,0,0,0,2.91-.33,5.76,5.76,0,0,0,2.1-1.81c.61-.72,1.18-1.43,1.73-2.12,2.19-2.77,4-5.21,5.35-7l0,0,0,0,3.12-2A9.2,9.2,0,0,1,136.72,464.74Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156,464.76a3.35,3.35,0,0,1-.66.24l-1.9.57-7,2,.12-.09a52.45,52.45,0,0,1-4.61,6.79,16.44,16.44,0,0,1-3.43,3.32,8,8,0,0,1-5,1.19,5.25,5.25,0,0,1-2.05-.63l-.21-.12.12-.22,7.6-14.45,0,0,0,0,5.56-4.15,1.54-1.1a3.82,3.82,0,0,1,.56-.36,3,3,0,0,1-.49.45l-1.47,1.19-5.47,4.28.06-.07c-2,3.92-4.62,9-7.49,14.51l-.09-.34a5,5,0,0,0,1.83.56,7.56,7.56,0,0,0,4.63-1.11,16.4,16.4,0,0,0,3.34-3.2,55.82,55.82,0,0,0,4.63-6.68l.05-.07.07,0,7-1.82,1.93-.47A3.46,3.46,0,0,1,156,464.76Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.38,478.15s-.06.05-.19.1a1.83,1.83,0,0,1-.62.16,3.19,3.19,0,0,1-2.24-.65,9.73,9.73,0,0,1-2.34-2.52c-.37-.54-.73-1.1-1.08-1.71a9.36,9.36,0,0,1-.85-2,25,25,0,0,1-.93-6.1l.09.16c-1.11-.81-2-1.48-2.65-2s-1-.77-.94-.81a5.52,5.52,0,0,1,1.08.61c.67.43,1.61,1.05,2.75,1.82l.08.06v.11a28.63,28.63,0,0,0,1,6,9.76,9.76,0,0,0,.79,1.93c.34.59.69,1.16,1,1.69a10.51,10.51,0,0,0,2.16,2.49,3.27,3.27,0,0,0,2,.75C173.08,478.21,173.36,478.09,173.38,478.15Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.41,451.11a10.46,10.46,0,0,1,3.66,8.5,37.13,37.13,0,0,0-1.32-4.47A36.44,36.44,0,0,0,169.41,451.11Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.18,204a9.38,9.38,0,0,0-9-15.38,11.22,11.22,0,0,0-17.37-8.32,12.6,12.6,0,0,0-15.53.47,9,9,0,0,0-7.14,15.61l46.08,25.32a9,9,0,0,0,2.93-17.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.82,189.79l2-.1a38.25,38.25,0,0,1,39.83,33.24c2.4,18.38,4.82,38.72,5.19,48.63.77,20.52-19.58,24.72-19.58,24.72l3,24.55-49.84.93-8.84-89.12C306.63,211.45,316.55,192.09,337.82,189.79Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.41,296.24a49.82,49.82,0,0,1-27.26-6.52s7.05,14.44,27.42,11.58Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.42,242.64a2.93,2.93,0,0,1-2.67,3.09,2.8,2.8,0,0,1-3.15-2.49,2.93,2.93,0,0,1,2.67-3.1A2.81,2.81,0,0,1,374.42,242.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.72,233.18c-.35.4-2.65-1.13-5.8-1s-5.38,1.86-5.74,1.49c-.17-.16.16-.87,1.13-1.66a8.13,8.13,0,0,1,4.57-1.66,7.8,7.8,0,0,1,4.64,1.25C375.53,232.32,375.89,233,375.72,233.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.73,244.75a2.94,2.94,0,0,1-2.68,3.1,2.82,2.82,0,0,1-3.15-2.49,2.94,2.94,0,0,1,2.68-3.1A2.8,2.8,0,0,1,347.73,244.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.78,235.3c-.35.4-2.65-1.13-5.8-1s-5.38,1.85-5.74,1.48c-.18-.16.16-.87,1.13-1.65a8,8,0,0,1,4.57-1.66,7.66,7.66,0,0,1,4.64,1.25C344.58,234.45,345,235.12,344.78,235.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.37,258.1c0-.18,1.92-.61,5.07-1.18.8-.12,1.56-.32,1.67-.87a4.1,4.1,0,0,0-.66-2.36c-.85-1.91-1.75-3.91-2.68-6-3.74-8.56-6.49-15.61-6.14-15.76s3.65,6.67,7.39,15.23c.9,2.11,1.77,4.12,2.59,6a4.73,4.73,0,0,1,.57,3.14,2,2,0,0,1-1.26,1.24,6,6,0,0,1-1.36.26C359.37,258.17,357.39,258.28,357.37,258.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.91,223.05c-.38.82-3.12.08-6.45.14s-6.1.75-6.45-.07c-.15-.38.41-1.13,1.57-1.83a10.06,10.06,0,0,1,4.94-1.3,9.71,9.71,0,0,1,4.89,1.24C346.55,221.92,347.07,222.66,346.91,223.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.22,220.18c-.62.75-3.26.13-6.39.25s-5.75.77-6.4,0c-.28-.35.1-1.08,1.22-1.82a10.2,10.2,0,0,1,5.14-1.43,10,10,0,0,1,5.17,1.19C375.1,219.1,375.5,219.82,375.22,220.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.19,213.62s-6.05-12.57-12.39-15.26c-7.67-3.25-10.49,5.14-17.73,3.49s-14.57-4.76-21.6,1.12c-7.69,6.44-3.74,10.5-3.78,19.62-.17,37-6.38,47.74-9.16,30.47-.31-1.9-5.66-3.15-6.85-11.15-1.53-10.38-2.56-23-.6-30.53,1.65-6.34,5-10.82,11.14-15.89,9.69-8,23.51-8.85,32.95-8.37S377.24,197.5,377.19,213.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.81,252.43a5.58,5.58,0,0,0-6.28-5.06c-3.8.55-7.95,2.94-7.31,10.82,1.15,14,15,10,14.95,9.56S314.34,258.29,313.81,252.43Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.7,262.73c-.07,0-.23.2-.63.42a2.44,2.44,0,0,1-1.82.18c-1.52-.42-3-2.66-3.23-5.18a8.08,8.08,0,0,1,.4-3.55,2.81,2.81,0,0,1,1.68-2,1.24,1.24,0,0,1,1.49.55c.22.38.15.67.23.68s.28-.26.12-.82a1.58,1.58,0,0,0-.62-.84,1.87,1.87,0,0,0-1.38-.24,3.44,3.44,0,0,0-2.37,2.38,8.32,8.32,0,0,0-.52,4c.32,2.81,2,5.33,4.05,5.75a2.67,2.67,0,0,0,2.2-.55C311.7,263.07,311.75,262.76,311.7,262.73Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.13,221.77c11.64-5.59,21.66-8.56,34.48-11.78s29.36-5.84,37.25-4.8a29.15,29.15,0,0,1,3.54,10.43s-53.69,4-74.5,17.45Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.29,220.6s0,3.54,4.8,5.35a5.11,5.11,0,0,0,6.42-2.08c.49-.86,2.52-3.45,2.52-3.45s3.14.62,4.32.69c4.1.23,8.63-5.36,8.6-8.94,1.11,1.5,3.15,1.34,4.94.77a6.87,6.87,0,0,0,3.38-2.83c2.72-3.65,1.77-6.74,1.77-6.74a14.62,14.62,0,0,0,5.75-1.85c1.36-1.2,3.88-4.32,4.07-6.16s-.86,4,.65,2.93,3.3-.55,5-.39,3.88-.34,4.23-2a3.35,3.35,0,0,0-.75-2.51,9.11,9.11,0,0,0-10.89-2.9,12.32,12.32,0,0,0-22.73-1.26,12.5,12.5,0,0,0-19.73,5.54,9.06,9.06,0,0,0-9.55,13.68c-2.45,1.56-5.27,4.3-4.39,7.07,2.61,8.26,8.83,6,11.59,5.1",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.35,194.54a1,1,0,0,1,0,.26,6.78,6.78,0,0,1-.06.75,8.63,8.63,0,0,1-.88,2.75,10.07,10.07,0,0,1-2.94,3.47,9.28,9.28,0,0,1-5.66,1.92l.22-.32a5.1,5.1,0,0,1-.09,3.89,14.42,14.42,0,0,1-2.23,3.56,10,10,0,0,1-1.49,1.69,4.89,4.89,0,0,1-2.18.93,5.13,5.13,0,0,1-4.59-1.39l.52-.18a10.54,10.54,0,0,1-4.1,7.5,7.67,7.67,0,0,1-4.53,1.74,14.06,14.06,0,0,1-4.58-.77l.36-.19a11.06,11.06,0,0,1-3.1,4.5,5.92,5.92,0,0,1-4.82,1.57,7.73,7.73,0,0,1-6.24-5.75l.32.13a7.22,7.22,0,0,1-4.78,1,7.85,7.85,0,0,1-3.43-1.33,6.63,6.63,0,0,1-1.65-1.64,4.37,4.37,0,0,1-.4-.7,8.67,8.67,0,0,0,2.18,2.14,7.68,7.68,0,0,0,3.34,1.19,6.9,6.9,0,0,0,4.51-1l.26-.16.07.29a7.27,7.27,0,0,0,5.9,5.32,5.32,5.32,0,0,0,4.37-1.48,10.43,10.43,0,0,0,2.91-4.26l.1-.26.27.08a13.35,13.35,0,0,0,4.39.73,7.11,7.11,0,0,0,4.18-1.61,10,10,0,0,0,3.87-7.07l.06-.67.46.5a4.58,4.58,0,0,0,4.06,1.23,4.44,4.44,0,0,0,1.93-.82,9.8,9.8,0,0,0,1.4-1.58,14.11,14.11,0,0,0,2.18-3.41,4.6,4.6,0,0,0,.14-3.52l-.14-.33h.36a9.1,9.1,0,0,0,5.43-1.76,10.09,10.09,0,0,0,2.93-3.29A11.2,11.2,0,0,0,356.35,194.54Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.04,
    y: 201.82,
    width: 20.6,
    height: 14.37,
    rx: 2.24,
    transform: "translate(-24.34 49.47) rotate(-7.56)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.28,215.07s.23,0,.62-.24a2.21,2.21,0,0,0,1.14-1.4,2.86,2.86,0,0,0,0-1.33c-.08-.51-.16-1-.24-1.64l-.57-4c-.1-.75-.21-1.52-.32-2.33l-.18-1.24a2.07,2.07,0,0,0-.42-1.09,2.13,2.13,0,0,0-2.24-.71l-2.86.39-12.75,1.71a2,2,0,0,0-1.71,2.1q.21,1.65.42,3.24c.27,2.13.54,4.19.8,6.15a3.09,3.09,0,0,0,.33,1.31,2.09,2.09,0,0,0,1,.82,2.2,2.2,0,0,0,1.25.12l1.33-.17,4.85-.61,7-.85,1.92-.21a2.83,2.83,0,0,1,.67,0,5.61,5.61,0,0,1-.66.14l-1.9.3-7,1-4.85.68-1.32.18a2.71,2.71,0,0,1-1.48-.13,2.5,2.5,0,0,1-1.18-1,3.63,3.63,0,0,1-.41-1.5q-.39-2.94-.83-6.14c-.14-1.08-.28-2.17-.43-3.27a2.52,2.52,0,0,1,2.16-2.66L366.13,201l2.86-.37a3,3,0,0,1,1.47.07,2.42,2.42,0,0,1,1.17.84,2.5,2.5,0,0,1,.5,1.3l.15,1.24c.11.81.2,1.58.3,2.33.18,1.47.34,2.81.49,4,.07.59.13,1.14.19,1.65a3,3,0,0,1,0,1.42,2.26,2.26,0,0,1-1.29,1.44A1.68,1.68,0,0,1,371.28,215.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M354.83,202.83h3.67a0,0,0,0,1,0,0v14.39a0,0,0,0,1,0,0h-3.67a2.57,2.57,0,0,1-2.57-2.57v-9.24A2.57,2.57,0,0,1,354.83,202.83Z",
    transform: "translate(-24.53 48.55) rotate(-7.56)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M370.66,208.71a5.37,5.37,0,1,1-5.37-5.37A5.36,5.36,0,0,1,370.66,208.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.66,208.71c-.05,0,0-.48-.27-1.29a5.34,5.34,0,0,0-2-2.83,5.22,5.22,0,0,0-4.89-.7,5.15,5.15,0,1,0,4.89,8.94,5.34,5.34,0,0,0,2-2.83c.23-.81.22-1.29.27-1.29s0,.12,0,.35a4.24,4.24,0,0,1-.11,1,5.38,5.38,0,0,1-1.94,3.08,5.52,5.52,0,0,1-5.27.85,5.41,5.41,0,0,1-2.62-1.94,5.59,5.59,0,0,1,0-6.66,5.47,5.47,0,0,1,2.62-1.94,5.55,5.55,0,0,1,5.27.85,5.38,5.38,0,0,1,1.94,3.08,4.26,4.26,0,0,1,.11,1C370.69,208.59,370.68,208.71,370.66,208.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.75,265.47h0a13.18,13.18,0,0,0-4-1.37,4,4,0,0,0-4.82,4.93,6,6,0,0,0,3.41,4.72,4.71,4.71,0,0,0,5.5-1.29,6.21,6.21,0,0,0,1-3.57C357.88,267.12,357.28,265.62,356.75,265.47Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.36,271.91c.05,0-.16.34-.63.81a7.63,7.63,0,0,1-2.32,1.61,3.55,3.55,0,0,1-2.09.2,6,6,0,0,1-2.13-.93,5.27,5.27,0,0,1-1.8-1.91,8.39,8.39,0,0,1-.74-2.64,5,5,0,0,1,1.85-4.92,3.78,3.78,0,0,1,2.35-.55,7.57,7.57,0,0,1,1.95.44,16.21,16.21,0,0,1,2.58,1c.56.38.78.68.75.73s-.36-.13-.94-.37-1.47-.37-2.62-.7a4.32,4.32,0,0,0-3.54.21,4.18,4.18,0,0,0-1.35,4,7.92,7.92,0,0,0,.62,2.3,4.37,4.37,0,0,0,1.43,1.59,3.78,3.78,0,0,0,3.41.83,10.29,10.29,0,0,0,2.34-1.23C357,272.05,357.32,271.85,357.36,271.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 599.52,
    cy: 199.82,
    rx: 94.4,
    ry: 98.1,
    transform: "translate(-11.46 38.41) rotate(-3.63)",
    style: {
      fill: "#00274C"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M505.3,205.77c-2.6-40.92,19.34-77.51,52.72-94.32L363.53,203.89c-4.85,1.68-5.2,7.81,1.27,10.42l198.31,75.8C531.13,276,507.74,244.17,505.3,205.77Z",
    style: {
      fill: "#00274C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M514,135.6c.07.13-27,13.18-60.48,29.15s-60.66,28.82-60.72,28.69,27-13.18,60.49-29.16S513.91,135.47,514,135.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.11,176.2a1.63,1.63,0,0,1,.11.4c.06.3.15.7.26,1.21s.24,1.2.4,2,.34,1.68.47,2.7a97.62,97.62,0,0,1,1.2,17.44,109.75,109.75,0,0,1-.89,12.05c-.17,1.07-.34,2.16-.52,3.27l-.27,1.68c-.11.56-.23,1.12-.35,1.69-.23,1.13-.48,2.28-.72,3.45l-.92,3.5A102.19,102.19,0,0,1,673,254.49a104.47,104.47,0,0,1-10.13,13,111.64,111.64,0,0,1-11.23,10.43A90.84,90.84,0,0,1,629.26,291a65.11,65.11,0,0,1-16.91,4.34l-1.45.18c-.46.05-.89.05-1.28.07l-2,.09-1.24,0H606a2,2,0,0,1,.42-.05l1.23-.1,2-.13c.39,0,.82,0,1.27-.1l1.44-.21a66.36,66.36,0,0,0,16.81-4.47,91.64,91.64,0,0,0,22.18-13.11,110.71,110.71,0,0,0,11.16-10.4,106,106,0,0,0,10.07-12.91,103,103,0,0,0,12.88-28.78l.92-3.48c.25-1.16.49-2.3.74-3.43.11-.57.23-1.13.35-1.68l.27-1.67c.18-1.1.36-2.19.53-3.26a109.6,109.6,0,0,0,.95-12,103.17,103.17,0,0,0-1-17.39c-.11-1-.27-1.93-.42-2.71l-.36-2c-.08-.51-.15-.92-.2-1.22S687.11,176.2,687.11,176.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.91,168a64,64,0,0,0-2.18-6.57,66.36,66.36,0,0,0-3.37-6,6.58,6.58,0,0,1,1.36,1.54,23,23,0,0,1,4,9A6.13,6.13,0,0,1,683.91,168Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.47,290.19c-.05.13-22.15-8.08-49.35-18.33S481.9,253.17,482,253s22.15,8.07,49.36,18.33S580.52,290.05,580.47,290.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400,317.41c-19.22,7.46-9.59,5.9-9.61,38.34,0,33.47,7.66,50.2,7.66,50.2l52.34-26.71-15-30.78C426.49,329.39,422.34,324.5,400,317.41Z",
    style: {
      fill: "#00274C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "301.12 318.27 323.74 309.41 365.39 307.05 384.97 314.49 358.14 329.39 335.01 328.54 301.12 318.27",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.79,390.4l-7.75-73s-20.4-7-30.81-10.36c0,0-11,11.42-31.78,11.11-20.37-.3-24.62-4.9-24.62-4.9l-28.47,10.92S266,332.44,260.63,340.4c-7.42,10.93-27,38.15-27,38.15l36.57,33L279.31,401l1.8,43.22c38,1.73,87.38,2.75,127.89-.16l-.81-29.52Z",
    style: {
      fill: "#00274C"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "358.34 368.65 359.92 399.69 380.39 408.84 395.53 395.94 395.53 367.22 358.34 368.65"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M265.33,357.64a51.29,51.29,0,0,0,13.4,36.56C276,381.54,269,369.76,265.33,357.64Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M410.71,344.83a1.91,1.91,0,0,1,0,.5c0,.38,0,.86,0,1.43-.06,1.32-.14,3.09-.25,5.24-.23,4.43-.6,10.54-1.07,17.29-.93,13.49-1.94,24.47-2.46,24.36a8.47,8.47,0,0,0,.27-1.89c.12-1.23.27-3,.44-5.22.32-4.5.76-10.57,1.24-17.28s.9-12.78,1.22-17.28c.17-2.15.31-3.92.41-5.24.05-.56.1-1,.14-1.42A1.53,1.53,0,0,1,410.71,344.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.69,354.82a4.52,4.52,0,0,1,.33.71l.86,2.06c.75,1.84,1.79,4.43,3.07,7.6l10,25.17c.36.93.72,1.86,1.06,2.72l0,0v.05c.42,9.86.79,18.66,1.07,25.07.11,3.14.2,5.68.26,7.5,0,.85,0,1.52.05,2a3.75,3.75,0,0,1,0,.7,3,3,0,0,1-.08-.7c0-.51-.09-1.18-.14-2-.11-1.82-.25-4.36-.43-7.49-.31-6.41-.74-15.21-1.23-25.07l0,.08c-.34-.87-.7-1.79-1.07-2.72l-9.81-25.22-2.92-7.67-.76-2.09A3.36,3.36,0,0,1,263.69,354.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418,444.12l-19.14.53V385.16a9.58,9.58,0,0,1,9.57-9.57h0a9.58,9.58,0,0,1,9.57,9.57Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.71,445.45l-20.27-.53,1.14-58.36a9.56,9.56,0,0,1,9.57-9.57h0a9.56,9.56,0,0,1,9.56,9.57Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.59,
    y: 421.63,
    width: 93.79,
    height: 13.89,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.77,445c-.14,0-.26-12.88-.26-28.76s.12-28.77.26-28.77.26,12.88.26,28.77S315.92,445,315.77,445Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.88,443.65c-.14,0-.26-11.2-.26-25s.12-25,.26-25,.26,11.19.26,25S399,443.65,398.88,443.65Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Text--inject-108"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M568.3,204.54l-7.28-.12-.16,9.38-13.51-.24.16-9.38-25.9-.44.16-9,22.5-30.21,14.35.25L538.18,193l9.94.17.15-8.33,13.09.23-.15,8.33,7.28.12Z",
    style: {
      fill: "#00274C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.36,189.47c.28-16.17,9.54-25.32,22.07-25.11s21.4,9.68,21.12,25.85-9.54,25.33-22,25.11S571.08,205.64,571.36,189.47Zm29.26.5c.18-10.29-3-14.19-7.39-14.27s-7.76,3.72-7.94,14,3,14.2,7.46,14.27S600.44,200.26,600.62,190Z",
    style: {
      fill: "#00274C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.24,206.21l-7.28-.12-.16,9.37-13.51-.23.16-9.38-25.9-.44.16-9,22.5-30.21,14.35.24L635.12,194.7l9.94.17.15-8.33,13.09.23-.15,8.33,7.28.12Z",
    style: {
      fill: "#00274C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574,237.22l-.07,3.63-13.34-.22.29-16.62,13,.22-.06,3.63-8.38-.14,0,2.8,7.38.13-.06,3.51-7.38-.13,0,3Z",
    style: {
      fill: "#00274C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.84,236.61l-2.56,0L581.2,241l-4.7-.08.28-16.62,7.6.13c4.53.08,7.34,2.48,7.28,6.28a5.51,5.51,0,0,1-3.35,5.19l3.5,5.28-5-.08Zm.19-8.5-2.61,0-.08,4.86,2.61,0c1.95,0,2.93-.85,3-2.37S586,228.15,584,228.11Z",
    style: {
      fill: "#00274C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.41,236.91l-2.57,0-.07,4.41-4.7-.08.28-16.62,7.6.14c4.53.07,7.34,2.47,7.28,6.27a5.5,5.5,0,0,1-3.35,5.19l3.5,5.29-5-.09Zm.19-8.5-2.61,0-.08,4.87,2.61,0c1.94,0,2.93-.85,3-2.37S603.55,228.45,601.6,228.41Z",
    style: {
      fill: "#00274C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.93,233.18c.08-5,4.06-8.57,9.38-8.48s9.17,3.81,9.09,8.8-4.07,8.57-9.39,8.48S610.84,238.17,610.93,233.18Zm13.72.24a4.5,4.5,0,1,0-4.57,4.67A4.46,4.46,0,0,0,624.65,233.42Z",
    style: {
      fill: "#00274C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.06,237.56l-2.56,0-.08,4.41-4.7-.08.29-16.62,7.6.13c4.53.08,7.34,2.48,7.27,6.28a5.52,5.52,0,0,1-3.34,5.19l3.5,5.28-5-.08Zm.2-8.5-2.61,0-.09,4.86,2.61.05c2,0,2.94-.85,3-2.37S641.2,229.1,639.26,229.06Z",
    style: {
      fill: "#00274C"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M568.3,204.54l-7.28-.12-.16,9.38-13.51-.24.16-9.38-25.9-.44.16-9,22.5-30.21,14.35.25L538.18,193l9.94.17.15-8.33,13.09.23-.15,8.33,7.28.12Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M571.36,189.47c.28-16.17,9.54-25.32,22.07-25.11s21.4,9.68,21.12,25.85-9.54,25.33-22,25.11S571.08,205.64,571.36,189.47Zm29.26.5c.18-10.29-3-14.19-7.39-14.27s-7.76,3.72-7.94,14,3,14.2,7.46,14.27S600.44,200.26,600.62,190Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M665.24,206.21l-7.28-.12-.16,9.37-13.51-.23.16-9.38-25.9-.44.16-9,22.5-30.21,14.35.24L635.12,194.7l9.94.17.15-8.33,13.09.23-.15,8.33,7.28.12Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M574,237.22l-.07,3.63-13.34-.22.29-16.62,13,.22-.06,3.63-8.38-.14,0,2.8,7.38.13-.06,3.51-7.38-.13,0,3Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M583.84,236.61l-2.56,0L581.2,241l-4.7-.08.28-16.62,7.6.13c4.53.08,7.34,2.48,7.28,6.28a5.51,5.51,0,0,1-3.35,5.19l3.5,5.28-5-.08Zm.19-8.5-2.61,0-.08,4.86,2.61,0c1.95,0,2.93-.85,3-2.37S586,228.15,584,228.11Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M601.41,236.91l-2.57,0-.07,4.41-4.7-.08.28-16.62,7.6.14c4.53.07,7.34,2.47,7.28,6.27a5.5,5.5,0,0,1-3.35,5.19l3.5,5.29-5-.09Zm.19-8.5-2.61,0-.08,4.87,2.61,0c1.94,0,2.93-.85,3-2.37S603.55,228.45,601.6,228.41Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M610.93,233.18c.08-5,4.06-8.57,9.38-8.48s9.17,3.81,9.09,8.8-4.07,8.57-9.39,8.48S610.84,238.17,610.93,233.18Zm13.72.24a4.5,4.5,0,1,0-4.57,4.67A4.46,4.46,0,0,0,624.65,233.42Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M639.06,237.56l-2.56,0-.08,4.41-4.7-.08.29-16.62,7.6.13c4.53.08,7.34,2.48,7.27,6.28a5.52,5.52,0,0,1-3.34,5.19l3.5,5.28-5-.08Zm.2-8.5-2.61,0-.09,4.86,2.61.05c2,0,2.94-.85,3-2.37S641.2,229.1,639.26,229.06Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.5e2bf75e65536f98b95cd425dc228903.svg";
export { ForwardRef as ReactComponent };